import React from "react";
import Carousel from "react-bootstrap/Carousel";

function FawnCarousel() {
  return (
    <div>
      <Carousel style={{ padding: "", backgroundColor: "transparent" }}>
        <Carousel.Item>
          <Carousel.Caption></Carousel.Caption>
          <div className="card">
            <div className="card-body">
              <img
                className="d-block"
                style={{ width: "80%", marginLeft: "10%", height: "10%" }}
                src="/images/fawn-logo.png"
                alt="First slide"
              />
            </div>
          </div>
        </Carousel.Item>
      </Carousel>
    </div>
  );
}

export default FawnCarousel;
